import { useState, useEffect } from "react"

import { Spinner } from "components/Spinner"
import { InfoBox } from "components/infoBox"
import { PaymentSystemType } from "utils/interfaces"
import { YooKassaWidget } from "components/PaymentWidget/YooKassa"
import { PaymentStatus } from "components/ClientCardAttachment/constants"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { getPaymentStatus } from "modules/BookingCommon/common/utils"
import { useDidMount } from "utils/customHooks"
import { httpClient } from "utils/infrastructure/httpClient"

const STATE_STATUS = {
    loading: "loading",
    error: "error",
    payment: "payment",
    paid: "paid",
    on_payment: "on_payment",
    after_payment: "after_payment",
}

interface AddClientToolData {
    order_id: string
    order_hash: string
}

const MAX_ATTEMPTS = 10

interface Props {
    onClose?: () => void
}

export function ClientCardAttachment({ onClose }: Props) {
    const [status, setStatus] = useState(STATE_STATUS.loading)
    const [message, setMessage] = useState("")
    const [paymentId, setPaymentId] = useState("")
    const [attempts, setAttempts] = useState(0)
    const [orderId, setOrderId] = useState("")
    const [orderHash, setOrderHash] = useState("")

    useDidMount(() => {
        httpClient
            .post<AddClientToolData>("payment/client-tools/add")
            .then((data) => {
                setOrderId(data.order_id)
                setOrderHash(data.order_hash)
                setStatus(STATE_STATUS.payment)
            })
            .catch((e) => console.log(e))
    })

    useEffect(() => {
        if (status !== STATE_STATUS.on_payment) return

        if (attempts >= MAX_ATTEMPTS) {
            setStatus(STATE_STATUS.error)
            setMessage("Не смогли получить подтверждение оплаты")
        } else if (status !== STATE_STATUS.after_payment && paymentId) {
            fetchingPaymentStatus(paymentId)
        }
    }, [status, attempts])

    function fetchingPaymentStatus(paymentId: string) {
        if (!paymentId) {
            setStatus(STATE_STATUS.error)
            setMessage("Ошибка при запросе статуса платежа")
        }

        getPaymentStatus(paymentId)
            .then((data) => {
                if (data.paid) {
                    setStatus(STATE_STATUS.after_payment)
                    if (onClose && status !== STATE_STATUS.after_payment) onClose()
                } else if (data.status === PaymentStatus.PAYMENT_ERROR) {
                    setStatus(STATE_STATUS.error)
                    setMessage("Ошибка оплаты")
                } else {
                    setAttempts(attempts + 1)
                }
            })
            .catch(() => {
                setStatus(STATE_STATUS.error)
                setMessage("Ошибка при запросе статуса платежа")
                setAttempts(attempts + 1)
            })
    }

    function onPaymentError(error: string) {
        setStatus(STATE_STATUS.error)
        setMessage(error)
    }

    return (
        <>
            {(() => {
                switch (status) {
                    case STATE_STATUS.loading:
                        return <Spinner />
                    case STATE_STATUS.payment:
                        return (
                            <YooKassaWidget
                                payment_system={PaymentSystemType.YOOKASSA_DIRECT}
                                onError={onPaymentError}
                                order_id={orderId}
                                sessionType={SESSION_TYPE.TIME_REQUEST}
                                initUrl={`payment/order/${orderHash}/init`}
                                savePaymentTool={true}
                                onInit={(paymentId: string) => {
                                    setPaymentId(paymentId)
                                }}
                                onAfterPayment={() => {
                                    setStatus(STATE_STATUS.on_payment)
                                }}
                            />
                        )
                    case STATE_STATUS.on_payment:
                        return (
                            <div className="redesign-container">
                                <Spinner text="Ожидание завершения оплаты" />
                            </div>
                        )
                    case STATE_STATUS.after_payment:
                        return <InfoBox type="error" message={message} />
                    case STATE_STATUS.error:
                        return <InfoBox type="error" message={message} />
                    default:
                        return null
                }
            })()}
        </>
    )
}
